/* tslint:disable */
/* eslint-disable */
/**
 * Borrower API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InsuredWithLoansDto } from './InsuredWithLoansDto';
import {
    InsuredWithLoansDtoFromJSON,
    InsuredWithLoansDtoFromJSONTyped,
    InsuredWithLoansDtoToJSON,
    InsuredWithLoansDtoToJSONTyped,
} from './InsuredWithLoansDto';
import type { BorrowerHeaderTabDto } from './BorrowerHeaderTabDto';
import {
    BorrowerHeaderTabDtoFromJSON,
    BorrowerHeaderTabDtoFromJSONTyped,
    BorrowerHeaderTabDtoToJSON,
    BorrowerHeaderTabDtoToJSONTyped,
} from './BorrowerHeaderTabDto';

/**
 * 
 * @export
 * @interface BorrowerPricingHeaderInfoDto
 */
export interface BorrowerPricingHeaderInfoDto {
    /**
     * 
     * @type {InsuredWithLoansDto}
     * @memberof BorrowerPricingHeaderInfoDto
     */
    insuredWithLoans: InsuredWithLoansDto;
    /**
     * 
     * @type {Array<BorrowerHeaderTabDto>}
     * @memberof BorrowerPricingHeaderInfoDto
     */
    tabs: Array<BorrowerHeaderTabDto>;
}

/**
 * Check if a given object implements the BorrowerPricingHeaderInfoDto interface.
 */
export function instanceOfBorrowerPricingHeaderInfoDto(value: object): value is BorrowerPricingHeaderInfoDto {
    if (!('insuredWithLoans' in value) || value['insuredWithLoans'] === undefined) return false;
    if (!('tabs' in value) || value['tabs'] === undefined) return false;
    return true;
}

export function BorrowerPricingHeaderInfoDtoFromJSON(json: any): BorrowerPricingHeaderInfoDto {
    return BorrowerPricingHeaderInfoDtoFromJSONTyped(json, false);
}

export function BorrowerPricingHeaderInfoDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BorrowerPricingHeaderInfoDto {
    if (json == null) {
        return json;
    }
    return {
        
        'insuredWithLoans': InsuredWithLoansDtoFromJSON(json['insuredWithLoans']),
        'tabs': ((json['tabs'] as Array<any>).map(BorrowerHeaderTabDtoFromJSON)),
    };
}

export function BorrowerPricingHeaderInfoDtoToJSON(json: any): BorrowerPricingHeaderInfoDto {
    return BorrowerPricingHeaderInfoDtoToJSONTyped(json, false);
}

export function BorrowerPricingHeaderInfoDtoToJSONTyped(value?: BorrowerPricingHeaderInfoDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'insuredWithLoans': InsuredWithLoansDtoToJSON(value['insuredWithLoans']),
        'tabs': ((value['tabs'] as Array<any>).map(BorrowerHeaderTabDtoToJSON)),
    };
}

